import UserHeaderWithActions from "~components/users/UserHeaderWithActions"
import UserDetailTabs from "~components/users/UserDetailTabs"
import { UserShape } from "~shapes/user"

export interface UserDetailProps {
  user: UserShape
  isLoading: boolean
  updateUser: (user: UserShape) => void
}

const UserDetail = ({ user, isLoading, updateUser }: UserDetailProps) => {
  return (
    <>
      <UserHeaderWithActions
        user={user}
        isLoading={isLoading}
        updateUser={updateUser}
      />

      <div style={{ marginTop: 14 }}>
        <UserDetailTabs user={user} isLoading={isLoading} />
      </div>
    </>
  )
}

export default UserDetail
